import { render, staticRenderFns } from "./RequiredManage.vue?vue&type=template&id=74bc83ea&scoped=true"
import script from "./RequiredManage.vue?vue&type=script&lang=js"
export * from "./RequiredManage.vue?vue&type=script&lang=js"
import style0 from "./RequiredManage.vue?vue&type=style&index=0&id=74bc83ea&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc83ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74bc83ea')) {
      api.createRecord('74bc83ea', component.options)
    } else {
      api.reload('74bc83ea', component.options)
    }
    module.hot.accept("./RequiredManage.vue?vue&type=template&id=74bc83ea&scoped=true", function () {
      api.rerender('74bc83ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/requiredManage/RequiredManage.vue"
export default component.exports